
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_1yz9c_1r4z3_99",
  "series--bar": "awsui_series--bar_1yz9c_1r4z3_100",
  "series__rect": "awsui_series__rect_1yz9c_1r4z3_100",
  "exiting": "awsui_exiting_1yz9c_1r4z3_117",
  "awsui-motion-fade-out-0": "awsui_awsui-motion-fade-out-0_1yz9c_1r4z3_1",
  "root": "awsui_root_1yz9c_1r4z3_143",
  "series--highlighted": "awsui_series--highlighted_1yz9c_1r4z3_156",
  "series__bar--highlighted": "awsui_series__bar--highlighted_1yz9c_1r4z3_157",
  "series--dimmed": "awsui_series--dimmed_1yz9c_1r4z3_161",
  "series--threshold": "awsui_series--threshold_1yz9c_1r4z3_165",
  "bar-group": "awsui_bar-group_1yz9c_1r4z3_170"
};
  